// @generated by Peggy 5.1.1.
//
// https://peggyjs.org/


class peg$SyntaxError extends SyntaxError {
  constructor(message, expected, found, location) {
    super(message);
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";
  }

  format(sources) {
    let str = "Error: " + this.message;
    if (this.location) {
      let src = null;
      const st = sources.find(s => s.source === this.location.source);
      if (st) {
        src = st.text.split(/\r\n|\n|\r/g);
      }
      const s = this.location.start;
      const offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
        ? this.location.source.offset(s)
        : s;
      const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
      if (src) {
        const e = this.location.end;
        const filler = "".padEnd(offset_s.line.toString().length, " ");
        const line = src[s.line - 1];
        const last = s.line === e.line ? e.column : line.length + 1;
        const hatLen = (last - s.column) || 1;
        str += "\n --> " + loc + "\n"
            + filler + " |\n"
            + offset_s.line + " | " + line + "\n"
            + filler + " | " + "".padEnd(s.column - 1, " ")
            + "".padEnd(hatLen, "^");
      } else {
        str += "\n at " + loc;
      }
    }
    return str;
  }

  static buildMessage(expected, found) {
    function hex(ch) {
      return ch.codePointAt(0).toString(16).toUpperCase();
    }

    const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode")
      ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu")
      : null;
    function unicodeEscape(s) {
      if (nonPrintable) {
        return s.replace(nonPrintable,  ch => "\\u{" + hex(ch) + "}");
      }
      return s;
    }

    function escape(s, special) {
      return unicodeEscape(s
        .replace(special, "\\$&")
        .replace(/\0/g, "\\0")
        .replace(/\t/g, "\\t")
        .replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/[\x00-\x0F]/g,          ch => "\\x0" + hex(ch))
        .replace(/[\x10-\x1F\x7F-\x9F]/g, ch => "\\x"  + hex(ch)));
    }

    function literalEscape(s) {
      return escape(s, /[\\"]/g);
    }

    function classEscape(s) {
      return escape(s, /[\\\]^-]/g);
    }

    const DESCRIBE_EXPECTATION_FNS = {
      literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },

      class(expectation) {
        const escapedParts = expectation.parts.map(
          part => (Array.isArray(part)
            ? classEscape(part[0]) + "-" + classEscape(part[1])
            : classEscape(part))
        );

        return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
      },

      any() {
        return "any character";
      },

      end() {
        return "end of input";
      },

      other(expectation) {
        return expectation.description;
      },
    };

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      const descriptions = expected.map(describeExpectation);
      descriptions.sort();

      if (descriptions.length > 0) {
        let j = 1;
        for (let i = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }
        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ")
            + ", or "
            + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  }
}

function peg$parse(input, options) {
  options = options !== undefined ? options : {};

  const peg$FAILED = {};
  const peg$source = options.grammarSource;

  const peg$startRuleFunctions = {
    start: peg$parsestart,
  };
  let peg$startRuleFunction = peg$parsestart;

  const peg$c0 = "&&";
  const peg$c1 = "||";
  const peg$c2 = "<=";
  const peg$c3 = ">=";
  const peg$c4 = "!=";
  const peg$c5 = "**";
  const peg$c6 = "(";
  const peg$c7 = ")";
  const peg$c8 = "[";
  const peg$c9 = "]";
  const peg$c10 = ",";
  const peg$c11 = "'";
  const peg$c12 = "true";
  const peg$c13 = "TRUE";
  const peg$c14 = "false";
  const peg$c15 = "FALSE";
  const peg$c16 = "null";
  const peg$c17 = "NULL";


  const peg$e0 = peg$literalExpectation("&&", false);
  const peg$e1 = peg$literalExpectation("||", false);
  const peg$e2 = peg$literalExpectation("<=", false);
  const peg$e3 = peg$literalExpectation(">=", false);
  const peg$e4 = peg$literalExpectation("!=", false);
  const peg$e5 = peg$classExpectation([["<", ">"]], false, false, false);
  const peg$e6 = peg$classExpectation(["+", "-"], false, false, false);
  const peg$e7 = peg$classExpectation(["%", "*", "/"], false, false, false);
  const peg$e8 = peg$literalExpectation("**", false);
  const peg$e9 = peg$literalExpectation("(", false);
  const peg$e10 = peg$literalExpectation(")", false);
  const peg$e11 = peg$classExpectation([["0", "9"], ["a", "z"], ["A", "Z"]], false, false, false);
  const peg$e12 = peg$literalExpectation("[", false);
  const peg$e13 = peg$literalExpectation("]", false);
  const peg$e14 = peg$literalExpectation(",", false);
  const peg$e15 = peg$classExpectation([["0", "9"], ["a", "z"], ["A", "Z"], ".", "_", "-"], false, false, false);
  const peg$e16 = peg$literalExpectation("'", false);
  const peg$e17 = peg$classExpectation(["'"], true, false, false);
  const peg$e18 = peg$classExpectation([["0", "9"]], false, false, false);
  const peg$e19 = peg$literalExpectation("true", false);
  const peg$e20 = peg$literalExpectation("TRUE", false);
  const peg$e21 = peg$literalExpectation("false", false);
  const peg$e22 = peg$literalExpectation("FALSE", false);
  const peg$e23 = peg$literalExpectation("null", false);
  const peg$e24 = peg$literalExpectation("NULL", false);
  const peg$e25 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false, false);

  function peg$f0(left, operator, right) {
    return {
      type: 'operator',
      operator: operator,
      left: left,
      right: right,
    }
  }
  function peg$f1(left, operator, right) {
    return {
      type: 'operator',
      operator: operator,
      left: left,
      right: right,
    }
  }
  function peg$f2(left, operator, right) {
    return {
      type: 'operator',
      operator: operator,
      left: left,
      right: right,
    }
  }
  function peg$f3(left, operator, right) {
    return {
      type: 'operator',
      operator: operator,
      left: left,
      right: right,
    }
  }
  function peg$f4(left, operator, right) {
    return {
      type: 'operator',
      operator: operator,
      left: left,
      right: right,
    }
  }
  function peg$f5(terms) {
    return terms
  }
  function peg$f6(value) {
    return value
  }
  function peg$f7(value) {
    return value
  }
  function peg$f8(value) {
    return value
  }
  function peg$f9(value) {
    return value
  }
  function peg$f10(name, args) {
    return {
      // func -> functionにしたいが、後方互換を保つ関係で実現できなかった
      type: "func",
      name: name.join(''),
      args
    }
  }
  function peg$f11(elements) {
    return {
      type: "array",
      elements
    }
  }
  function peg$f12(m, ms) {
    return [m, ...ms]
  }
  function peg$f13(m) {
    return [m]
  }
  function peg$f14() {
    return []
  }
  function peg$f15(path) {
    return {
      type: "variable",
      path: path.join('').split('.')
    }
  }
  function peg$f16(value) {    
     return {
       type: "literal",
       literalType: "string",
       value: value.join('')
     }
  }
  function peg$f17(value) {    
     return {
       type: "literal",
       literalType: "number",
       value: Number(value.join(''))
     }
  }
  function peg$f18() {    
     return {
       type: "literal",
       literalType: "boolean",
       value: true
     }
  }
  function peg$f19() {    
     return {
       type: "literal",
       literalType: "boolean",
       value: false
     }
  }
  function peg$f20() {    
     return {
       type: "literal",
       literalType: "null",
       value: null
     }
  }
  function peg$f21() {    return  }
  let peg$currPos = options.peg$currPos | 0;
  let peg$savedPos = peg$currPos;
  const peg$posDetailsCache = [{ line: 1, column: 1 }];
  let peg$maxFailPos = peg$currPos;
  let peg$maxFailExpected = options.peg$maxFailExpected || [];
  let peg$silentFails = options.peg$silentFails | 0;

  let peg$resultsCache = new Map();

  let peg$result;
  let peg$charCode;

  if (options.startRule) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function offset() {
    return peg$savedPos;
  }

  function range() {
    return {
      source: peg$source,
      start: peg$savedPos,
      end: peg$currPos,
    };
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildSimpleError(message, location);
  }

  function peg$getUnicode(pos = peg$currPos) {
    const cp = input.codePointAt(pos);
    if (cp === undefined) {
      return "";
    }
    return String.fromCodePoint(cp);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text, ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
    return { type: "class", parts, inverted, ignoreCase, unicode };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description };
  }

  function peg$computePosDetails(pos) {
    let details = peg$posDetailsCache[pos];
    let p;

    if (details) {
      return details;
    } else {
      if (pos >= peg$posDetailsCache.length) {
        p = peg$posDetailsCache.length - 1;
      } else {
        p = pos;
        while (!peg$posDetailsCache[--p]) {}
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column,
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  function peg$computeLocation(startPos, endPos, offset) {
    const startPosDetails = peg$computePosDetails(startPos);
    const endPosDetails = peg$computePosDetails(endPos);

    const res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column,
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column,
      },
    };
    if (offset && peg$source && (typeof peg$source.offset === "function")) {
      res.start = peg$source.offset(res.start);
      res.end = peg$source.offset(res.end);
    }
    return res;
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parsestart() {
    let s0;

    const key = peg$currPos * 27 + 0;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$parseexpression();

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseexpression() {
    let s0;

    const key = peg$currPos * 27 + 1;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$parselogicalitive();
    if (s0 === peg$FAILED) {
      s0 = peg$parseterm();
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseLogicalOperator() {
    let s0;

    const key = peg$currPos * 27 + 2;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    if (input.substr(peg$currPos, 2) === peg$c0) {
      s0 = peg$c0;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e0); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c1) {
        s0 = peg$c1;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e1); }
      }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parselogicalitive() {
    let s0, s1, s2, s3, s4, s5;

    const key = peg$currPos * 27 + 3;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseequalitive();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      s3 = peg$parseLogicalOperator();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parselogicalitive();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f0(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseequalitive();
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseEqualityOperator() {
    let s0;

    const key = peg$currPos * 27 + 4;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    if (input.substr(peg$currPos, 2) === peg$c2) {
      s0 = peg$c2;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e2); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c3) {
        s0 = peg$c3;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e3); }
      }
      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c4) {
          s0 = peg$c4;
          peg$currPos += 2;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e4); }
        }
        if (s0 === peg$FAILED) {
          s0 = input.charAt(peg$currPos);
          if ((peg$charCode = s0.charCodeAt(0), (peg$charCode >= 60 && peg$charCode <= 62))) {
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e5); }
          }
        }
      }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseequalitive() {
    let s0, s1, s2, s3, s4, s5;

    const key = peg$currPos * 27 + 5;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseadditive();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      s3 = peg$parseEqualityOperator();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parseequalitive();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f1(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseadditive();
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseAdditiveOperator() {
    let s0;

    const key = peg$currPos * 27 + 6;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = input.charAt(peg$currPos);
    if ((peg$charCode = s0.charCodeAt(0), peg$charCode === 43 || peg$charCode === 45)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e6); }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseadditive() {
    let s0, s1, s2, s3, s4, s5;

    const key = peg$currPos * 27 + 7;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parsemulticative();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      s3 = peg$parseAdditiveOperator();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parseadditive();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f2(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parsemulticative();
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseMultiplicativeOperator() {
    let s0;

    const key = peg$currPos * 27 + 8;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = input.charAt(peg$currPos);
    if ((peg$charCode = s0.charCodeAt(0), peg$charCode === 37 || peg$charCode === 42 || peg$charCode === 47)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e7); }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parsemulticative() {
    let s0, s1, s2, s3, s4, s5;

    const key = peg$currPos * 27 + 9;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseexponentiation();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      s3 = peg$parseMultiplicativeOperator();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parsemulticative();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f3(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseexponentiation();
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseExponentialOperator() {
    let s0;

    const key = peg$currPos * 27 + 10;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    if (input.substr(peg$currPos, 2) === peg$c5) {
      s0 = peg$c5;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e8); }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseexponentiation() {
    let s0, s1, s2, s3, s4, s5;

    const key = peg$currPos * 27 + 11;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parsebracket();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      s3 = peg$parseExponentialOperator();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parseexponentiation();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f4(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parsebracket();
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parsebracket() {
    let s0, s1, s2, s3, s4, s5;

    const key = peg$currPos * 27 + 12;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 40) {
      s1 = peg$c6;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e9); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      s3 = peg$parselogicalitive();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        if (input.charCodeAt(peg$currPos) === 41) {
          s5 = peg$c7;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e10); }
        }
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f5(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseterm();
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseterm() {
    let s0, s1;

    const key = peg$currPos * 27 + 13;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parsefunction();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f6(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsearray();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f7(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseliteral();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f8(s1);
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parsevariable();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f9(s1);
          }
          s0 = s1;
        }
      }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parsefunction() {
    let s0, s1, s2, s3, s4, s5, s6;

    const key = peg$currPos * 27 + 14;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = [];
    for (;;) {
      s2 = input.charAt(peg$currPos);
      if ((peg$charCode = s2.charCodeAt(0), (peg$charCode >= 48 && peg$charCode <= 57) || (peg$charCode >= 97 && peg$charCode <= 122) || (peg$charCode >= 65 && peg$charCode <= 90))) {
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e11); }
      }
      if (s2 === peg$FAILED) { break; }
      s1.push(s2);
    }
    if (s1.length < 1) {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c6;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e9); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        s4 = peg$parseexpressions();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (input.charCodeAt(peg$currPos) === 41) {
            s6 = peg$c7;
            peg$currPos++;
          } else {
            s6 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e10); }
          }
          if (s6 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f10(s1, s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parsearray() {
    let s0, s1, s2, s3, s4, s5;

    const key = peg$currPos * 27 + 15;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 91) {
      s1 = peg$c8;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e12); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      s3 = peg$parseexpressions();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        if (input.charCodeAt(peg$currPos) === 93) {
          s5 = peg$c9;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e13); }
        }
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f11(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseexpressions() {
    let s0, s1, s2, s3, s4, s5;

    const key = peg$currPos * 27 + 16;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseexpression();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (input.charCodeAt(peg$currPos) === 44) {
        s3 = peg$c10;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e14); }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parseexpressions();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f12(s1, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseexpression();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f13(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = '';
        peg$savedPos = s0;
        s1 = peg$f14();
        s0 = s1;
      }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parsevariable() {
    let s0, s1, s2;

    const key = peg$currPos * 27 + 17;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = [];
    for (;;) {
      s2 = input.charAt(peg$currPos);
      if ((peg$charCode = s2.charCodeAt(0), (peg$charCode >= 48 && peg$charCode <= 57) || (peg$charCode >= 97 && peg$charCode <= 122) || (peg$charCode >= 65 && peg$charCode <= 90) || peg$charCode === 46 || peg$charCode === 95 || peg$charCode === 45)) {
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e15); }
      }
      if (s2 === peg$FAILED) { break; }
      s1.push(s2);
    }
    if (s1.length < 1) {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f15(s1);
    }
    s0 = s1;

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseliteral() {
    let s0;

    const key = peg$currPos * 27 + 18;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$parseboolean();
    if (s0 === peg$FAILED) {
      s0 = peg$parsestring();
      if (s0 === peg$FAILED) {
        s0 = peg$parsenumber();
        if (s0 === peg$FAILED) {
          s0 = peg$parsenull();
        }
      }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parsestring() {
    let s0, s1, s2, s3;

    const key = peg$currPos * 27 + 19;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 39) {
      s1 = peg$c11;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e16); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      for (;;) {
        s3 = input.charAt(peg$currPos);
        if (s3 !== "" && !(peg$charCode = s3.charCodeAt(0), peg$charCode === 39)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e17); }
        }
        if (s3 === peg$FAILED) { break; }
        s2.push(s3);
      }
      if (s2.length < 1) {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 39) {
          s3 = peg$c11;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e16); }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f16(s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parsenumber() {
    let s0, s1, s2;

    const key = peg$currPos * 27 + 20;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = [];
    for (;;) {
      s2 = input.charAt(peg$currPos);
      if ((peg$charCode = s2.charCodeAt(0), (peg$charCode >= 48 && peg$charCode <= 57))) {
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e18); }
      }
      if (s2 === peg$FAILED) { break; }
      s1.push(s2);
    }
    if (s1.length < 1) {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f17(s1);
    }
    s0 = s1;

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseboolean() {
    let s0, s1;

    const key = peg$currPos * 27 + 21;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseTrueToken();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f18();
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseFalseToken();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f19();
      }
      s0 = s1;
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseTrueToken() {
    let s0;

    const key = peg$currPos * 27 + 22;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    if (input.substr(peg$currPos, 4) === peg$c12) {
      s0 = peg$c12;
      peg$currPos += 4;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e19); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c13) {
        s0 = peg$c13;
        peg$currPos += 4;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e20); }
      }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseFalseToken() {
    let s0;

    const key = peg$currPos * 27 + 23;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    if (input.substr(peg$currPos, 5) === peg$c14) {
      s0 = peg$c14;
      peg$currPos += 5;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e21); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 5) === peg$c15) {
        s0 = peg$c15;
        peg$currPos += 5;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e22); }
      }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parsenull() {
    let s0, s1;

    const key = peg$currPos * 27 + 24;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseNullToken();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f20();
    }
    s0 = s1;

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parseNullToken() {
    let s0;

    const key = peg$currPos * 27 + 25;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    if (input.substr(peg$currPos, 4) === peg$c16) {
      s0 = peg$c16;
      peg$currPos += 4;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e23); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c17) {
        s0 = peg$c17;
        peg$currPos += 4;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e24); }
      }
    }

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  function peg$parse_() {
    let s0, s1, s2;

    const key = peg$currPos * 27 + 26;
    const cached = peg$resultsCache.get(key);

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    peg$silentFails++;
    s0 = peg$currPos;
    s1 = [];
    for (;;) {
      s2 = input.charAt(peg$currPos);
      if ((peg$charCode = s2.charCodeAt(0), peg$charCode === 32 || peg$charCode === 9 || peg$charCode === 10 || peg$charCode === 13)) {
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e25); }
      }
      if (s2 === peg$FAILED) { break; }
      s1.push(s2);
    }
    peg$savedPos = s0;
    s1 = peg$f21();
    s0 = s1;
    peg$silentFails--;

    peg$resultsCache.set(key, { nextPos: peg$currPos, result: s0 });

    return s0;
  }

  peg$result = peg$startRuleFunction();

  const peg$success = (peg$result !== peg$FAILED && peg$currPos === input.length);
  function peg$throw() {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
  if (options.peg$library) {
    return /** @type {any} */ ({
      peg$result,
      peg$currPos,
      peg$FAILED,
      peg$maxFailExpected,
      peg$maxFailPos,
      peg$success,
      peg$throw: peg$success ? undefined : peg$throw,
    });
  }
  if (peg$success) {
    return peg$result;
  } else {
    peg$throw();
  }
}

const peg$allowedStartRules = [
  "start"
];

export {
  peg$allowedStartRules as StartRules,
  peg$SyntaxError as SyntaxError,
  peg$parse as parse
};
